import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import useStore from '@/hooks/useStore';
import { CategoryName, CATEGORY_KEY_BY_NAME } from '@popularKeyword/common-types';

type HeadLineMoreProps = {
  categoryName?: CategoryName;
  isRisingKeyword?: boolean;
};
type GetDetailPageUrlProps = {
  domain: 'pc' | 'mw';
  isRisingKeyword: boolean;
  total: number;
  categoryName?: CategoryName;
  currentDate?: string;
};
//FIX ME: pc, mo 공통 유틸로 추상화
const getDetailPageUrl = ({
  domain,
  isRisingKeyword,
  categoryName,
  currentDate,
  total,
}: GetDetailPageUrlProps): string => {
  const isCategoryDetail = !isRisingKeyword && categoryName;

  const params: Record<string, string> = {
    domain,
    type: 'detail',
    rising: isCategoryDetail ? 'false' : 'true',
    page: '0',
    total,
  };

  if (isCategoryDetail && categoryName) {
    params.category = CATEGORY_KEY_BY_NAME[categoryName];
    if (currentDate) params.date = currentDate;
    if (typeof total === 'number') params.total = total.toString();
  }

  return `?${new URLSearchParams(params).toString()}`;
};
const HeadLineMore = ({ categoryName, isRisingKeyword = false }: HeadLineMoreProps) => {
  const { RisingKeywordStore, MonthlyKeywordStore } = useStore();

  const { risingTotalDataCount } = RisingKeywordStore;
  const { currentDate, getTotalItemCountByCategory } = MonthlyKeywordStore;

  const totalItemCount = isRisingKeyword ? risingTotalDataCount : getTotalItemCountByCategory(categoryName);

  const newPath = getDetailPageUrl({
    domain: 'pc',
    isRisingKeyword,
    categoryName,
    currentDate,
    total: totalItemCount,
  });
  const path = newPath;

  return (
    <p className="c-p-headline__more">
      <Link to={path} className="c-p-more c-p-more--arrow-right">
        전체 보기
      </Link>
    </p>
  );
};

export default observer(HeadLineMore);
